"use strict";

var _classCallCheck = require("/Users/xavieraguas/Documents/Github_Repository/IVAN/Landing-Page-Ecommerce-Assistant/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/xavieraguas/Documents/Github_Repository/IVAN/Landing-Page-Ecommerce-Assistant/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleShape = void 0;

var CircleShape = /*#__PURE__*/function () {
  function CircleShape() {
    _classCallCheck(this, CircleShape);
  }

  _createClass(CircleShape, [{
    key: "randomPosition",
    value: function randomPosition(position, offset, fill) {
      var generateTheta = function generateTheta(x, y) {
        var u = Math.random() / 4.0;
        var theta = Math.atan(y / x * Math.tan(2 * Math.PI * u));
        var v = Math.random();

        if (v < 0.25) {
          return theta;
        } else if (v < 0.5) {
          return Math.PI - theta;
        } else if (v < 0.75) {
          return Math.PI + theta;
        } else {
          return -theta;
        }
      };

      var radius = function radius(x, y, theta) {
        return x * y / Math.sqrt(Math.pow(y * Math.cos(theta), 2) + Math.pow(x * Math.sin(theta), 2));
      };

      var a = offset.x / 2,
          b = offset.y / 2;
      var randomTheta = generateTheta(a, b),
          maxRadius = radius(a, b, randomTheta),
          randomRadius = fill ? maxRadius * Math.sqrt(Math.random()) : maxRadius;
      return {
        x: position.x + randomRadius * Math.cos(randomTheta),
        y: position.y + randomRadius * Math.sin(randomTheta)
      };
    }
  }]);

  return CircleShape;
}();

exports.CircleShape = CircleShape;